'use client';

import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { DateRange } from 'react-day-picker';
import { BookableDate } from '@prisma/client';

interface DesktopCalendarProps {
  isOpen: boolean;
  onOpenChange: (_open: boolean) => void;
  date: DateRange | undefined;
  handleDateChange: (_range: DateRange | undefined, _selectedDay?: Date) => void;
  minStay: number | null;
  dateMatcher: (_day: Date) => boolean;
  bookableDates: BookableDate[];
  startMonth?: Date;
}

export function DesktopCalendar({
  isOpen,
  onOpenChange,
  date,
  handleDateChange,
  minStay,
  dateMatcher,
  bookableDates,
  startMonth,
}: DesktopCalendarProps) {
  return (
    <Popover open={isOpen} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="flex-col items-start w-full h-auto">
          <span className="font-semibold uppercase text-[0.65rem]">CHECK IN - CHECK OUT</span>
          <span className="font-normal">
            {date?.from ? date.from.toLocaleDateString() : 'Select'} -{' '}
            {date?.to ? date.to.toLocaleDateString() : 'dates'}
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-4">
        <Calendar
          mode="range"
          min={minStay || 1}
          required={true}
          excludeDisabled={true}
          disabled={dateMatcher}
          numberOfMonths={2}
          selected={date}
          bookableDates={bookableDates}
          startMonth={startMonth}
          onSelect={handleDateChange}
          onClose={() => onOpenChange(false)}
          showOutsideDays={false}
        />

        {minStay && (
          <div className="mb-4">
            <p className="text-base font-bold uppercase">
              MINIMUM STAY: {minStay} {minStay === 1 ? 'night' : 'nights'}
            </p>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
